import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Card,
    CardBody,
    Button,
    Input,
    Label,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import Switch from 'rc-switch';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'rc-switch/assets/index.css';
import '../../style/style.css';
import { API_Ingetration } from '../../../../../../constants/APIs';
const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ]
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];

export default function HelpCenterChatBot({ botSettings, saveIntegration, locale }) {
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings.chatBot !== null &&
        !botSettings.chatBot.botDisabled
    );
    const [integrationList, setIntegrationList] = useState([]);
    const [chatBotDetails, setChatBotDetails] = useState([]);
    const [botInputData, setBotInputData] = useState({
        botDisabled: false,
        botIntegrationId: "",
        botIntegrationIcon: ""
    });
    useEffect(() => {
        let body = {
            channels: ['WebsiteDirectLine']
        };
        AxiosAPI({
            method: 'post',
            url: `${API_Ingetration}?group_id=${getGroupID()}`,
            data: body
        }).then((res) => {
            const webIntegrationData = res.data.filter(
                (k) => k.channel === 'WebsiteDirectLine' && k.disabled === false
            );
            setIntegrationList(webIntegrationData);
        });
        if (botSettings !== undefined && botSettings.chatBot !== null) {
            var chatbot = botSettings.chatBot.chatBotDetails.filter(i => i.locale === locale);
            if (chatbot.length > 0) {
                setChatBotDetails({
                    title: chatbot[0].title,
                    subTitle: chatbot[0].subTitle,
                    contactInformation: chatbot[0].contactInformation,
                    locale: locale
                })
            } else {
                var chatbotEn = botSettings.chatBot.chatBotDetails.filter(i => i.locale === "en");
                if (chatbotEn.length > 0) {
                    setChatBotDetails({
                        title: chatbotEn[0].title,
                        subTitle: chatbotEn[0].subTitle,
                        contactInformation: chatbotEn[0].contactInformation,
                        locale: locale
                    });
                }
            }
            setBotInputData({
                ...botSettings.chatBot,
                botDisabled: botSettings.chatBot.botDisabled,
                botIntegrationIcon: botSettings.chatBot.botIntegrationIcon,
                botIntegrationId: botSettings.chatBot.botIntegrationId
            });
        }
    }, [botSettings]);

    const handleSave = (e) => {
        let setting = botSettings;
        var existingDetail = setting.chatBot.chatBotDetails.filter(i => i.locale !== locale);
        var assitantdata = [...existingDetail, chatBotDetails];
        var chatbot = { ...botInputData, chatBotDetails: assitantdata };
        setting.chatBot = chatbot;
        saveIntegration({
            botSetting: setting
        });
    };
    const handleTextChange = (e) => {
        setChatBotDetails({ ...chatBotDetails, [e.target.name]: e.target.value });
    }
    const handleChange = (e) => {
        var integration = integrationList.filter(i => i.id === e.target.value).map(k => k.botSettings !== null && k.botSettings.urls && k.botSettings.urls.icon);
        const iconUrl = integration.length > 0 ? integration[0] : "";
        setBotInputData({ ...botInputData, botIntegrationId: e.target.value, botIntegrationIcon: iconUrl });
    };
    const handleChangeContact = (source, data) => {
        if (source === 'user') {
            setChatBotDetails({ ...chatBotDetails, contactInformation: data });
        }
    };
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setBotInputData({
            ...botInputData,
            botDisabled: !value
        });
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody>
                    <h6 className="text-center">Add Chatbot or Contact Info </h6>
                    <Separator className="mb-3" />
                    <Row>
                        <Colxx md={12} className="mt-2">
                            <div className="d-flex w-100">
                                <Label>Enable Chatbot</Label>
                                <Switch
                                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                    checked={checkedPrimarySmall}
                                    onChange={(primary) => handleSwitchChange(primary)}
                                />
                            </div>
                        </Colxx>
                        <Colxx md={12} className="mt-2">
                            <Label>Title</Label>
                            <div className="mb-2">
                                <Input
                                    type="text"
                                    name="title"
                                    placeholder="Title"
                                    value={chatBotDetails.title}
                                    onChange={(e) => handleTextChange(e)}
                                ></Input>
                            </div>
                        </Colxx>
                        <Colxx md={12} className="mt-2">
                            <Label>Sub Title</Label>
                            <div className="mb-2">
                                <Input
                                    type="text"
                                    name="subTitle"
                                    placeholder="Sub Title"
                                    value={chatBotDetails.subTitle}
                                    onChange={(e) => handleTextChange(e)}
                                ></Input>
                            </div>
                        </Colxx>
                        <Colxx md={12} className="mt-2">
                            <Label>Select Chatbot to Integrate</Label>
                            <div className="mb-2">
                                <Input
                                    type="select"
                                    className="dropdown-menu dropdowntimezone"
                                    name="botIntegtrationId"
                                    value={botInputData.botIntegrationId}
                                    onChange={(e) => handleChange(e)}
                                >
                                    <option value={""}>Select Integration</option>
                                    {integrationList.map((item, i) => (
                                        <option value={item.id} key={i}>
                                            {item.name === null || item.name === "" ? item.botSettings.name : item.name + " - " + item.botSettings.name}
                                        </option>
                                    ))}

                                </Input>
                            </div>
                        </Colxx>
                        {botInputData.botDisabled === true && (
                            <Colxx md={12} className="mt-3">
                                <Label>Contact Information</Label>
                                <ReactQuill
                                    theme="snow"
                                    value={chatBotDetails.contactInformation}
                                    onChange={(content, delta, source) =>
                                        handleChangeContact(source, content)
                                    }
                                    modules={quillModules}
                                    formats={quillFormats}
                                    name="contactInformation"
                                />
                            </Colxx>
                        )}
                        <Colxx md={12} className="mt-4 text-center">
                            <Button
                                color="primary"
                                size="xs"
                                className="mt-1"
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                        </Colxx>
                    </Row>
                </CardBody>
            </Card>
        </Fragment>
    );
}
